// extracted by mini-css-extract-plugin
export default {"containerWithButton":"home_containerWithButton__jysNp","buttonPanic":"home_buttonPanic__zQb4D"};